import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgPauseBig = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 94,
	height: 94,
	viewBox: "0 0 94 94",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [
		/* @__PURE__ */ _jsx("circle", {
			cx: 47,
			cy: 47,
			r: 47,
			fill: "white",
			fillOpacity: .3
		}),
		/* @__PURE__ */ _jsx("circle", {
			cx: 47,
			cy: 47,
			r: 35,
			fill: "white"
		}),
		/* @__PURE__ */ _jsx("path", {
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M38.2917 33.5H42.875C44.1407 33.5 45.1667 34.5074 45.1667 35.75V58.25C45.1667 59.4926 44.1407 60.5 42.875 60.5H38.2917C37.026 60.5 36 59.4926 36 58.25V35.75C36 34.5074 37.026 33.5 38.2917 33.5ZM52.0417 33.5H56.625C57.8907 33.5 58.9167 34.5074 58.9167 35.75V58.25C58.9167 59.4926 57.8907 60.5 56.625 60.5H52.0417C50.776 60.5 49.75 59.4926 49.75 58.25V35.75C49.75 34.5074 50.776 33.5 52.0417 33.5Z",
			fill: "#4D4D54"
		})
	]
});
export default SvgPauseBig;
